export default "__VITE_PUBLIC_ASSET__86d0fafd__"